/* v27.42 - Pick three varied five-star reviews from the Opinew data on the
   page and render them under the buy area. Also opens the full review
   feed (collapsed by default) when "See all reviews" is tapped. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function words(s) {
    var stop = /^(the|and|for|that|this|with|have|from|they|them|very|just|been|were|will|your|you|are|was|but|not|all|its|our|out|has|had|can|too|one|two|get|got|than|then|also|into|only|more|some|what|when|like|love|great|good|really|product|products|pink|stork|these|those|take|taking|took|them|been|did|does|day|days|every|much|well|now|how|any|about)$/;
    var out = {};
    String(s).toLowerCase().replace(/[^a-z\s]/g, ' ').split(/\s+/).forEach(function (w) {
      if (w.length > 3 && !stop.test(w)) out[w] = true;
    });
    return out;
  }

  function overlap(a, b) {
    var n = 0, t = 0, k;
    for (k in a) { t++; if (b[k]) n++; }
    for (k in b) { if (!a[k]) t++; }
    return t ? n / t : 0;
  }

  function collect() {
    var el = document.querySelector('#opinew-plugin[data-opw-prodreviews]');
    if (!el) return null;
    var data;
    try { data = JSON.parse(el.getAttribute('data-opw-prodreviews')); } catch (e) { return null; }
    var r = (data && data.reviews) || {};
    var seen = {}, list = [];
    ['smart', 'highest_rated', 'content', 'recent'].forEach(function (k) {
      (r[k] || []).forEach(function (x) {
        if (!x || seen[x.id]) return;
        seen[x.id] = true;
        list.push(x);
      });
    });
    return list;
  }

  function pick(list) {
    function usable(minStars, minLen, maxLen) {
      return list.filter(function (x) {
        var body = (x.body || '').trim();
        return x.star_rating >= minStars && !x.by_shop_owner && body.length >= minLen && body.length <= (maxLen || 420) &&
          !/^\s*(good|great|love it|excellent)\s*[.!]*\s*$/i.test(body);
      });
    }
    // Prefer substantial five-star reviews; newer products with few
    // reviews fall back to shorter ones, then to four-star ones.
    var base = usable(5, 50);
    if (base.length < 3) base = usable(5, 25, 900);
    if (base.length < 3) base = usable(4, 25, 900);
    var cands = base.map(function (x) {
      var body = x.body.trim();
      var score = 0;
      score += Math.min(body.length, 260) / 260;            // substance
      if (x.verified_review) score += 0.6;                  // trust
      if (x.image_urls && x.image_urls.length) score += 0.3; // photo
      if (x.created_ts && /^202[5-9]/.test(x.created_ts)) score += 0.3; // recent
      if (/\bnause|stomach|sick|taste|smell|energy|sleep|cycle|hair|mood|easy|swallow|doctor|obgyn|midwife|recommend/i.test(body)) score += 0.3;
      var open = body.toLowerCase().replace(/[^a-z\s]/g, ' ').split(/\s+/).filter(Boolean).slice(0, 3).join(' ');
      return { r: x, w: words(body), s: score, open: open };
    }).sort(function (a, b) { return b.s - a.s; });

    var out = [];
    while (out.length < 3 && cands.length) {
      var best = null, bestVal = -1;
      cands.forEach(function (c) {
        var sim = 0;
        out.forEach(function (o) {
          sim = Math.max(sim, overlap(c.w, o.w));
          // Same opening words ("So far so good...") read as copies; avoid.
          if (c.open === o.open) sim = Math.max(sim, 0.6);
        });
        var val = c.s - sim * 2.5;
        if (val > bestVal) { bestVal = val; best = c; }
      });
      out.push(best);
      cands.splice(cands.indexOf(best), 1);
    }
    return out.map(function (c) { return c.r; });
  }

  function name(x) {
    var n = (x.user_name || '').trim();
    if (!n) return 'Verified customer';
    var p = n.split(/\s+/);
    if (p.length > 1 && p[1].length > 2) return p[0] + ' ' + p[1].charAt(0).toUpperCase() + '.';
    return n;
  }

  function render(root, picks) {
    var list = root.querySelector('[data-ps-top-reviews-list]');
    list.innerHTML = picks.map(function (x) {
      var body = esc(x.body.trim());
      var long = x.body.trim().length > 170;
      return '<li class="ps-top-reviews__item">' +
        '<div class="ps-top-reviews__top">' +
          '<span class="ps-top-reviews__stars" aria-label="' + x.star_rating + ' out of 5 stars">' + '★★★★★'.slice(0, x.star_rating) + '</span>' +
          '<span class="ps-top-reviews__name">' + esc(name(x)) + '</span>' +
          (x.verified_review ? '<span class="ps-top-reviews__verified"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>Verified</span>' : '') +
        '</div>' +
        '<p class="ps-top-reviews__body' + (long ? ' is-clamped' : '') + '">' + body + '</p>' +
        (long ? '<button type="button" class="ps-top-reviews__more" data-ps-more>Read more</button>' : '') +
      '</li>';
    }).join('');
    root.hidden = false;
    // Only keep "Read more" where the text is actually cut off.
    list.querySelectorAll('.ps-top-reviews__body.is-clamped').forEach(function (p) {
      if (p.scrollHeight <= p.clientHeight + 2) {
        p.classList.remove('is-clamped');
        var b = p.nextElementSibling;
        if (b && b.hasAttribute('data-ps-more')) b.remove();
      }
    });
  }

  function openFeed() {
    var feed = document.getElementById('reviews-feed');
    var sec = document.getElementById('reviews');
    if (feed) {
      feed.hidden = false;
      feed.removeAttribute('hidden');
      var btn = document.querySelector('[data-ps-reviews-toggle]');
      if (btn) btn.hidden = true;
      window.dispatchEvent(new Event('resize'));
    }
    (feed || sec) && (feed || sec).scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-ps-more]');
    if (more) {
      var p = more.previousElementSibling;
      if (p) p.classList.toggle('is-clamped');
      more.textContent = p && p.classList.contains('is-clamped') ? 'Read more' : 'Show less';
      return;
    }
    var open = e.target.closest('[data-ps-open-reviews], [data-ps-reviews-toggle]');
    if (open) { e.preventDefault(); openFeed(); }
  });

  function init() {
    var root = document.querySelector('[data-ps-top-reviews]');
    if (!root) return;
    var list = collect();
    if (!list) return false;
    var picks = pick(list);
    if (picks.length < 3) { root.hidden = true; return true; }
    render(root, picks);
    return true;
  }

  function start() {
    if (init() !== false) return;
    // Opinew block may be printed later than this script runs; try a few times.
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (init() !== false || tries > 20) clearInterval(t);
    }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  if (location.hash === '#reviews-feed') setTimeout(openFeed, 600);
})();
